<template>
  <div class="assignment-detail">
    <div class="assignment-detail__heading">
      <span class="assignment-detail__heading-name">{{ $t('assignments.details.detail_result_lesson_name') }}</span>
      <span class="assignment-detail__heading-results">{{ $t('assignments.details.detail_result_results') }}</span>
    </div>
    <assignment-detail-item
      v-for="(lesson, idx) in lessons"
      :key="lesson.id"
      :lesson="lesson"
      :order="Number(idx + 1)"
    />
  </div>
</template>

<script>
import AssignmentDetailItem from './AssignmentDetailItem.vue'
export default {
  components: {
    AssignmentDetailItem
  },

  props: {
    lessons: {
      type: Array,
      default: () => []
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';

.assignment-detail {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 600;

  &__heading {
    padding-right: 40px;
    display: flex;
    color: $gray-1;
  }

  &__heading-results {
    display: flex;
    justify-content: center;
    margin-left: auto;
    width: 15%;
  }
}
</style>
